<script lang="ts">
    import type { Product } from "../model";

    export let product: Product;

    export let color: string = "red";

    function buildXPercentDiscountAmout(product: Product): string {
        return `-${product.discountAmount}${product.discountUnit}`;
    }

    function buildXEuroDiscountAmout(product: Product): string {
        return `-${product.discountAmount}${product.discountUnit}`;
    }

    function buildDiscountPercentForXProduct(product: Product): string {
        return `-${product.discountAmount}${product.discountUnit} sur le ${product.discountPriceQty} produit`;
    }
</script>

{#if product.discountLabel}
    <div class="pastille {color}" class:fidelity={product.meca == "meca4"}>
        {#if product.meca == "meca1"}
            <div class="promotion">
                {buildXPercentDiscountAmout(product)}
            </div>
        {:else if product.meca == "meca2"}
            <div class="promotion">
                {buildXEuroDiscountAmout(product)}
            </div>
        {:else if product.meca == "meca3"}
            <div class="promotion-flex" style="">
                <div class="discount-percent">
                    -{Number(product.discountAmount).toFixed(2).split(".")[0]}%
                </div>
                <div class="discount-label">
                    <span>
                        SUR LE {product.discountPriceQty}e
                    </span>
                    <span> PRODUIT ACHETÉ </span>
                </div>
            </div>
        {:else if product.meca == "meca4"}
            <div class="promotion-flex fidelity">
                <div class="discount-percent">
                    {Number(product.discountAmount).toFixed(2).split(".")[0]}%
                </div>
                <div class="discount-label">
                    <span>
                        sur la carte de fidelité
                    </span>
                </div>
            </div>
        {/if}
    </div>
{/if}

<style lang="scss">
    @import "../styles/variables.scss";

    .promotion-flex {
        display: flex;
        flex-direction: column;
        text-align: center;
        flex-wrap: nowrap;
        gap: 1px;

        margin: 1rem auto auto auto;
        color: white;

        .discount-percent {
            font-size: 1.5rem;
            line-height: 1.5rem;
            font-family: "Diagramm Bold";
        }

        .discount-label {
            display: flex;
            flex-direction: column;
        }

        span {
            font-size: 0.5rem;
            line-height: 0.5rem;
            font-family: "Diagramm Bold";
        }
        .fidelity {
            font-size: 0.7rem;
            line-height: 0.7rem;
        }

        .small-text {
            font-size: 0.4rem;
            line-height: 0.4rem;
        }

    }
    .pastille {
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        display: flex;
        flex-direction: row;

        @media (max-width: $mobile-breakpoint) {
            // width: 3rem;
            // height: 3rem;
        }

        .promotion {
            color: white;
            font-size: 1.5rem;
            display: inline-flex;
            margin: auto;
            font-family: "Diagramm Bold";

            @media (max-width: $mobile-breakpoint) {
                // font-size: 0.8rem;
            }
        }

        &.red {
            background-color: red;
        }

        &.dark-green {
            background-color: $dark-green;
        }

        &.fidelity {
            background-color: $dark-blue !important;
        }

        &.light-green {
            background-color: greenyellow;
        }
    }
</style>
